(ns guidebook.specs
  (:require [cljs.spec.alpha :as s]
    [cljs.spec.gen.alpha :as gen]
    ["moment" :as moment]))

(s/def ::open? boolean?)
(s/def ::submitting? boolean?)
(s/def ::notes-modal (s/keys :opt-un [::open? ::submitting?]))

(defn- generate-date [random-selection]
  (let [start-date (.unix (.subtract (moment) 100 "years"))
        end-date (.unix (.add (moment) 1000 "years"))]
    (.toISOString (.unix moment (+ start-date (* random-selection (- end-date start-date)))))))

(s/def ::date (s/with-gen
                #(re-matches #"\d{4}-\d{2}-\d{2}T\d{2}:\d{2}.*" %)
                #(gen/fmap generate-date
                           (gen/double* {:infinite? false :NaN? false :min 0 :max 1}))))

(s/def ::target-date (s/nilable ::date))

(s/def ::goal (s/keys :req-un [::target-date]))
(s/def ::goals (s/coll-of ::goal))

(s/def ::priority (s/keys :req-un [::goals]))
(s/def ::priorities (s/coll-of ::priority))

(s/def ::client (s/keys :req-un [::priorities]))

(s/def ::alternatives double?)
(s/def ::cash double?)
(s/def ::equities double?)
(s/def ::fixed-income (s/nilable double?))
(s/def ::other (s/nilable double?))
(s/def ::investment (s/keys :req-un [::alternatives
                                     ::cash
                                     ::equities
                                     ::fixed-income
                                     ::other]))
(s/def ::current ::investment)
(s/def ::proposed ::investment)
(s/def ::recommendation (s/nilable (s/keys :req-un [::current
                                                    ::proposed])))

(s/def ::data (s/keys :req-un [::client
                               ::recommendation]))

;; you made me do this, carson
(s/def ::guidebook any?
  ;(s/keys :opt-un [::data ::notes-modal])
  )
